import { Avatar } from "@material-ui/core";
import useStyles, {
  GradientRoundedContainer,
  WhiteRoundedContainer,
  AvatarContainer,
  StyledLabelProps,
} from "./styles";
import GemIcon from "../GemIcon";
import { Container, ContainerProps, StyledLabelP } from "modules/Sty";
import useCurrentBrand from 'Hooks/useCurrentBrand';
import { PlanType } from "modules/Const";
import { clsx } from "modules/Utils";

interface Props {
  className: string;
  isWhiteBorder?: boolean;
  styles?: ContainerProps;
  proStatusStyles?: ContainerProps;
  userNameTextStyles?: StyledLabelProps;
  proTextStyles?: StyledLabelProps;
  userContainerStyles?: ContainerProps;
  avatarContainerStyles?: ContainerProps;
  isSmallSidebar?: boolean;
  imageOverride?: string;
  isCursorPointer?: boolean;
}

const AvatarUserStatus = ({
  className,
  isWhiteBorder = false,
  styles,
  proStatusStyles,
  userNameTextStyles,
  proTextStyles,
  avatarContainerStyles,
  userContainerStyles,
  isSmallSidebar,
  imageOverride = '',
  isCursorPointer = false,
}: Props) => {
  const classes = useStyles()
  const { currentBrand, isPaidBrand, getBrandImage } = useCurrentBrand()

  if (!currentBrand) {
    return null
  }

  const { image, name: brandName, connections } = currentBrand
  

  const avatar = imageOverride || image || getBrandImage() || ''

  /** Renders the custom avatar with optional gradient border based on subscription status */
  const renderCustomAvatar = () => {
    if (!isPaidBrand) {
      return (
        <Avatar src={avatar} className={classes.avatar} />
      )
    }

    if (isWhiteBorder) {
      return (
        <GradientRoundedContainer width="37px" height="37px" planType={currentBrand.tier}>
          <AvatarContainer top="2.3px">
            <Avatar src={avatar} className={classes.avatar} />
          </AvatarContainer>
        </GradientRoundedContainer>
      )
    }

    return (
      <GradientRoundedContainer width="42px" height="42px" planType={currentBrand.tier}>
        <WhiteRoundedContainer>
          <AvatarContainer top="3px">
            <Avatar src={avatar} className={classes.avatar} />
          </AvatarContainer>
        </WhiteRoundedContainer>
      </GradientRoundedContainer>
    )
  }

  const renderAccountStatus = () => {
    if (!currentBrand.tier) {
      return null
    }

    const tier = currentBrand.tier

    let text = ''
    let icon = null
    switch (tier) {
      case PlanType.PRO:
        text = 'PRO ACCOUNT'
        icon = <GemIcon />
        break
      case PlanType.LITE:
        text = 'LITE ACCOUNT'
        icon = <GemIcon />
        break
      default:
        text = ''
    }

    return (
      <Container className="avatarUserStatus" alignItems="center" {...proStatusStyles} display="flex">
        {icon}
        <StyledLabelP {...proTextStyles}>
          {text}
        </StyledLabelP>
      </Container>
    );
  };

  return (
    <Container
      className={clsx('avatarUserStatusContainer', className)}
      {...styles}
      display="flex"
      alignItems="center"
      cursor={isCursorPointer ? 'pointer' : 'default'}
    >
      <Container
        className="avatarUserStatusAvatarContainer"
        {...avatarContainerStyles}
        cursor={isCursorPointer ? 'pointer' : 'default'}
      >
        {renderCustomAvatar()}
      </Container>
      <Container
        className="avatarUserStatusUserContainer"
        {...userContainerStyles}
        cursor={isCursorPointer ? 'pointer' : 'default'}
        display={isSmallSidebar ? 'none' : 'flex'}
        flexDirection="column"
        alignItems="flex-start"
      >
        <StyledLabelP
          className="avatarUserStatusUserName"
          {...userNameTextStyles}
          style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}
        >
          {brandName}
        </StyledLabelP>
        {/* NOTE: uncomment this if you want to see the brand id in the dropdown */}
        {/* <div className="brandIdForAdmin">{currentBrand.id}</div> */}
        {renderAccountStatus()}
      </Container>
    </Container>
  )
}

export default AvatarUserStatus
